<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex justify-content-between align-items-center flex-1 gap-3">
        <div class="d-flex align-items-center gap-2">
          <div class="modal-title"><ng-container i18n>Property Unit</ng-container></div>
        </div>
        <div class="flex-fill"></div>
        <ng-container [ngSwitch]="tab$.value">
          <ng-container *ngSwitchCase="tabs.Details">
            <button (click)="close()" type="button" class="btn btn-secondary-light">
              <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
            </button>
            <button
              (click)="details?.save()"
              type="button"
              class="btn btn-secondary-info"
              [disabled]="details?.isSaving"
            >
              <i class="cs-icon cs-icon-save" *ngIf="!details?.isSaving"></i>
              <i class="far fa-spinner fa-spin" *ngIf="details?.isSaving"></i>
              <ng-container i18n>Save</ng-container>
            </button>
          </ng-container>
          <ng-container *ngSwitchCase="tabs.Licenses">
            <button (click)="close()" type="button" class="btn btn-secondary-light">
              <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
            </button>
            <button
              (click)="licenses?.save()"
              type="button"
              class="btn btn-secondary-info"
              [disabled]="licenses?.isLoading || !licenses?.isLicenseRequired"
            >
              <i class="cs-icon cs-icon-save" *ngIf="!licenses?.isLoading"></i>
              <i class="far fa-spinner fa-spin" *ngIf="licenses?.isLoading"></i>
              <ng-container i18n>Save</ng-container>
            </button>
          </ng-container>
          <ng-container *ngSwitchCase="tabs.Bathrooms">
            <button (click)="close()" type="button" class="btn btn-secondary-light">
              <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
            </button>
            <button
              (click)="bathroom?.save()"
              type="button"
              class="btn btn-secondary-info"
              [disabled]="bathroom?.isLoading || !bathroom?.form?.valid"
            >
              <i class="cs-icon cs-icon-save" *ngIf="!bathroom?.isLoading"></i>
              <i class="far fa-spinner fa-spin" *ngIf="bathroom?.isLoading"></i>
              <ng-container i18n>Save</ng-container>
            </button>
          </ng-container>
        </ng-container>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom" role="tablist" *ngIf="isEdit">
      <li [class.active]="tab$.value === tabs.Details">
        <a (click)="tab$.next(tabs.Details)" i18n> Details </a>
      </li>
      <li [class.active]="tab$.value === tabs.Amenities">
        <a (click)="tab$.next(tabs.Amenities)" i18n> Amenities </a>
      </li>
      <li [class.active]="tab$.value === tabs.Bathrooms">
        <a (click)="tab$.next(tabs.Bathrooms)" i18n> Bathrooms </a>
      </li>
      <li [class.active]="tab$.value === tabs.Licenses">
        <a (click)="tab$.next(tabs.Licenses)" i18n> Licenses </a>
      </li>
      <li [class.active]="tab$.value === tabs.Gallery">
        <a (click)="tab$.next(tabs.Gallery)" i18n> Gallery </a>
      </li>
    </ul>

    <div class="modal-body">
      <app-bdc-property-unit-details
        #details
        *ngIf="tab$.value === tabs.Details"
        [propertyId]="propertyId"
        [propertyTypeId]="propertyTypeId"
        [unit]="unit"
        (close)="close()"
      ></app-bdc-property-unit-details>
      <app-bdc-property-unit-amenities
        #amenities
        *ngIf="tab$.value === tabs.Amenities"
        [propertyId]="propertyId"
        [roomId]="unit?.unit_id"
      ></app-bdc-property-unit-amenities>
      <app-bdc-property-unit-bathroom
        #bathroom
        *ngIf="tab$.value === tabs.Bathrooms"
        [propertyId]="propertyId"
        [propertyTypeId]="propertyTypeId"
        [roomId]="unit?.unit_id"
        [roomTypeId]="unit?.configuration?.unit_type_id"
      ></app-bdc-property-unit-bathroom>
      <app-bdc-property-unit-license
        #licenses
        *ngIf="tab$.value === tabs.Licenses"
        [propertyId]="propertyId"
        [roomId]="unit?.unit_id"
      ></app-bdc-property-unit-license>
      <app-bdc-property-unit-gallery
        #gallery
        *ngIf="tab$.value === tabs.Gallery"
        [propertyId]="propertyId"
        [roomId]="unit?.unit_id"
      ></app-bdc-property-unit-gallery>
    </div>
  </div>
</div>
